const DEFAULT_ERROR_MESSAGE = 'Something went wrong. Please try again.';

const TECHNICAL_ERROR_PATTERNS = [
  /\bdb\b/i,
  /\bdatabase\b/i,
  /\bmongo(db)?\b/i,
  /\bmongoose\b/i,
  /\bmysql\b/i,
  /\bpostgres(?:ql)?\b/i,
  /\bredis\b/i,
  /\bsequelize\b/i,
  /\bprisma\b/i,
  /\bfusion\s*auth\b/i,
  /\bconnection (?:failure|failed|refused|reset|timed out|timeout)\b/i,
  /\bservice unavailable\b/i,
  /\binternal server error\b/i,
  /\bbad gateway\b/i,
  /\bgateway timeout\b/i,
  /\bexception\b/i,
  /\bstack trace\b/i,
  /\bquery failed\b/i,
  /\bsqlstate\b/i,
  /\beconnrefused\b/i,
  /\beconnreset\b/i,
  /\betimedout\b/i,
  /\benotfound\b/i,
  /<\/?[a-z][\s\S]*>/i,
];

const normalizeErrorMessage = (message) => (
  typeof message === 'string' ? message.replace(/\s+/g, ' ').trim() : ''
);

export const getPublicErrorMessage = (
  message,
  fallback = DEFAULT_ERROR_MESSAGE
) => {
  const normalizedMessage = normalizeErrorMessage(message);

  if (!normalizedMessage) {
    return fallback;
  }

  if (
    normalizedMessage.length > 180 ||
    TECHNICAL_ERROR_PATTERNS.some((pattern) => pattern.test(normalizedMessage))
  ) {
    return fallback;
  }

  return normalizedMessage;
};

export const getWorkspaceErrorMessage = (statusCode, message) => {
  if (statusCode === 404) {
    return 'Workspace not found. Check the workspace ID and try again.';
  }

  return getPublicErrorMessage(
    message,
    'We could not verify that workspace right now. Please try again.'
  );
};

export const getLoginErrorMessage = (statusCode, message) => {
  if (statusCode === 401) {
    return 'Incorrect email or password.';
  }

  if (statusCode === 404) {
    return 'We could not find your account. Please contact your administrator.';
  }

  return getPublicErrorMessage(
    message,
    'We could not sign you in right now. Please try again.'
  );
};

export const getSsoErrorMessage = (message) =>
  getPublicErrorMessage(
    message,
    'Single sign-on failed. Please try again or contact your administrator.'
  );

export const SESSION_EXPIRED_MESSAGE = 'Your session expired. Please log in again.';
